import { useEffect } from "react";

/**
 * Client-side page meta. Google renders JS before indexing, so this is enough for
 * per-page titles/descriptions/canonicals; the static tags in index.html remain the
 * fallback for non-rendering crawlers (Facebook, LinkedIn).
 */
export default function useSeo({ title, description, canonical, noindex = false }) {
  useEffect(() => {
    if (title) document.title = title;

    const set = (selector, attrs) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement(attrs.tag || "meta");
        Object.entries(attrs).forEach(([k, v]) => k !== "tag" && el.setAttribute(k, v));
        document.head.appendChild(el);
      }
      return el;
    };

    if (description) {
      set('meta[name="description"]', { name: "description" }).setAttribute("content", description);
      set('meta[property="og:description"]', { property: "og:description" }).setAttribute("content", description);
    }
    if (title) {
      set('meta[property="og:title"]', { property: "og:title" }).setAttribute("content", title);
    }

    const href = canonical
      ? `${window.location.origin}${canonical}`
      : `${window.location.origin}${window.location.pathname}`;
    set('link[rel="canonical"]', { tag: "link", rel: "canonical" }).setAttribute("href", href);

    const robots = set('meta[name="robots"]', { name: "robots" });
    robots.setAttribute("content", noindex ? "noindex, nofollow" : "index, follow");

    return () => robots.setAttribute("content", "index, follow");
  }, [title, description, canonical, noindex]);
}
